import {IconButton} from '@mui/material'
import {React} from 'common'
import MenuIcon from '@mui/icons-material/Menu'
import {getMobileSideMenuSx} from 'appearance/styles'

const MobileSideMenuButton = ({handleMobileSideMenuOpen, displayMode}) => {
    return (
        <IconButton
            size="large"
            edge="start"
            color="primary"
            aria-label="open drawer"
            onClick={handleMobileSideMenuOpen}
            sx={getMobileSideMenuSx(displayMode)}>
            <MenuIcon />
        </IconButton>
    )
}

export default MobileSideMenuButton
